module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/MCqgLP/tc-custom/9781504083768.jpg?1726444246414",
      "alt": "This image is the cover for the book Hills Like White Elephants"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Hills Like White Elephants\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("A couple’s future hangs in the balance as they wait for a train in a Spanish café in this short story by a Nobel and Pulitzer Prize–winning author.")])]), _c('p', [_vm._v(" At a small café in rural Spain, a man and woman have a conversation while they wait for their train to Madrid. The subtle, casual nature of their talk masks a more complicated situation that could endanger the future of their relationship. ")]), _vm._v(" First published in the 1927 collection "), _c('i', [_vm._v("Men Without Women")]), _vm._v(", “Hills Like White Elephants” exemplifies Ernest Hemingway’s style of spare, tight prose that continues to win readers over to this day.\n    "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Ernest Hemingway\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Ernest Hemingway was an American journalist, novelist, short story writer, and sportsman. His economical and understated style, which he termed “the iceberg theory,” had a strong influence on twentieth-century fiction, while his adventurous lifestyle and public image brought him admiration from later generations.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Media\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0